
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import MultiStepEventEncounter from '@/components/sports/common/event/MultiStepEventEncounter.vue';
import ProvideUpcomingEventData from '@/components/sports/common/overview/upcoming-event/ProvideUpcomingEventData.vue';
import Subheading from '@/components/sports/common/Subheading.vue';

import { ObjectType, SportType } from '@/@types/graphql-types';
import type Provider from '@/interfaces/provider';
import { SportLocale } from '@/enums/sports';
import { SportPageType } from '@/interfaces/sport-graphql';
import { SnowplowSportContext } from '@/helpers/tracking/providers';

const Constant = namespace('constant');
const Language = namespace('language');

@Component({
	name: 'MultiStepEventEncounterList',
	components: { Subheading, MultiStepEventEncounter, HiddenHorizontalScrollbar, ProvideUpcomingEventData },
})
export default class MultiStepEventEncounterList extends Vue {
	domainSessionId: string | null = null;

	@Prop() filterBy: 'sport' | 'competition';
	@Prop() filterByName: string; // sport name or competition name
	@Prop() filterByParam: SportType | string;
	@Prop() sportType: SportType;
	@Prop({ default: false }) withCompetitionInHeader: boolean;
	@Prop() sportPageType: SportPageType;

	@Constant.Getter providersById: Record<string, Provider>;
	@Language.State webLocale: SportLocale;

	@Language.Getter locale: string;
	@Language.Getter country: string;

	get sportContext() {
		const objectType = this.getObjectTypeFromSportPageType(this.sportPageType);
		const sportType = this.sportType || this.filterByParam; // TODO check why on Event page sportType is undefined
		if (!objectType || !sportType) return [];
		return [new SnowplowSportContext(sportType, objectType)];
	}

	getObjectTypeFromSportPageType(pageType: string): ObjectType {
		if (pageType == SportPageType.SportOverview) {
			return ObjectType.Sport;
		}
		return pageType as ObjectType;
	}
	async created() {
		this.domainSessionId = await TrackingHelper.getDomainSessionId();
	}

	getSubheading(eventTimeGroup: 'live' | 'today' | 'upcoming') {
		// this will support:
		//
		// SPORT EVENTS:
		// - $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_UPCOMING')
		// - $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_LIVE')
		// - $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_TODAY')
		//
		// COMPETITION EVENTS:
		// - $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_UPCOMING')
		// - $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_LIVE')
		// - $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_TODAY')
		const translatable = `SPORTS_WEBAPP_HEADER_${this.filterBy.toUpperCase()}_EVENTS_${eventTimeGroup.toUpperCase()}`;
		const translationMatches =
			this.sportType === SportType.FormulaRacing
				? this.$t('SPORTS_WEBAPP_RACES')
				: this.$t('SPORTS_WEBAPP_MATCHES');
		return this.$t(translatable, { event: this.filterByName, type: translationMatches });
	}
}
